module.exports = __webpack_public_path__ + "img/gallery-5.179e9ad3.png";